import { Component, ViewChild, TemplateRef, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

@Component({
  selector: 'app-impact-assessment-fields',
  templateUrl: './impact-assessment-fields.component.html',
  styleUrls: ['./impact-assessment-fields.component.scss']
})
export class ImpactAssessmentFieldsComponent implements OnInit, OnDestroy {

  isProcessing = false;
  field: any = {};
  auditTrail: any = {};

  templateId: number;
  module: any;

  constructor(
    private readonly dialog: MatDialog,
    private readonly elem: ElementRef,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
    private readonly paginationService: PaginationService,
    private readonly router: Router,

    public readonly message: messageService,
  ) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.message.breadcrumbData.fourthLevel = data.template.templateName;
    this.templateId = data.template.templateId;
    this.module = data.template.module;
  }


  fieldTypeList: any = [];
  fieldTypeDropDown: any = [];
  fieldTypeSearchText: string = '';

  ngOnInit() {
    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_FIELDTYPE").subscribe((data: any) => {
      this.fieldTypeList = data;
      this.selectBoxForFieldType();
    });
    this.getCall();
  }

  selectBoxForFieldType() {
    this.fieldTypeDropDown = this.fieldTypeList?.map((field: any) => ({
      valueExp: field.codelistCode,
      displayExp: field.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  ngOnDestroy() {
    this.message.breadcrumbData.fourthLevel = '';
  }

  backToTemplate() {
    this.message.isFromImpactAssessmentFields = true;
    this.router.navigate(['dashboard/impact-assessment-template'], {
      state: { module: this.module }
    });
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value); searchBox?.focus();
    }, 0)
  }

  onFieldTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('field-type', item);
    }
  }

  handleDropDownValidation(fieldId: string, item: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = item ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. Id → ', fieldId);
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    position: { top: '10px' },
  };

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  popupTitle: string = '';
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.popupTitle = "Add Fields";
    this.field = {};
    this.field.isActive = true;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingFieldId: number;
  openEditPopup(editingData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.popupTitle = "Edit " + editingData.FIELD_NAME + " field";
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    this.editingFieldId = editingData.FIELD_ID;

    this.appService.getImpactAssessmentFieldByFieldId(this.editingFieldId).subscribe((field: any) => {
      this.field = field;
      this.field.updateReason = '';
      this.field.isActive = this.field.isActive == 'Y';
      this.isProcessing = false;
    })
  }

  deletingFieldId: number;
  openDeletePopup(deletingData: any) {
    this.popupTitle = "Delete Field";
    this.deletingFieldId = deletingData.FIELD_ID;
    this.field.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  closeAddEditPopup() {
    this.visibleAddAndEditPopup.close();
  }

  closeDeletePopup() {
    this.visibleDeletePopup.close();
  }

  fieldValidation(elementIds: string[]) {
    for (const elementId of elementIds) {
      const element = document.getElementById(elementId) as HTMLInputElement | null;
      if (element) {
        element.style.color = 'red';
      }
    }
  }
  addAndEditFunction(field: any) {

    const validations = [
      { condition: !field.fieldName, id: 'field-name' },
      { condition: !field.fieldTypeCode, id: 'field-type' },
      { condition: field.fieldTypeCode != 'Document Repository' && field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field' && !field.fieldValues, id: 'field-values' },
      { condition: !field.updateReason && this.visibleEditButton, id: 'update-reason' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar('Please enter all Mandatory Fields!', 'E');
    } else {
      this.isProcessing = true;

      const obj = {
        templateId: this.templateId,
        fieldName: field.fieldName,
        fieldTypeCode: field.fieldTypeCode,
        fieldValues: field.fieldValues,
        isActive: field.isActive ? 'Y' : 'N',
      }

      if (this.visibleAddButton) {
        this.create(obj);
      } else {
        const modifiedObj = {
          ...obj, fieldId: this.editingFieldId, updateReason: field.updateReason
        }
        this.update(modifiedObj);
      }
    }
  }

  create(obj: any) {
    this.appService.createImpactAssessmentField(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  update(obj: any) {
    this.appService.updateImpactAssessmentField(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  deleteFunction(field: any) {
    if (field.deleteReason) {
      this.isProcessing = true;

      const obj = {
        fieldId: this.deletingFieldId,
        deleteReason: field.deleteReason,
        templateId: this.templateId
      }

      this.appService.deleteImpactAssessmentField(obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  parentCheckBox: boolean = false;
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, field: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : field.FIELD_ID;
    this.auditTrail.gridName = "IMPACT_ASSESSMENT_FIELDS";
    this.auditTrail.report_And_Popup_Name = 'Impact Assessment Fields';
    this.dynamicAuditTrailComponent.triggerTrail(field);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.gridObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Impact Assessment Fields';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.gridObj.gridName, this.gridObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  getDynamicLabel() {
    this.isProcessing = true;
    const data = {
      tableName: this.gridObj.tableOrViewName,
      moduleName: null,
      gridName: this.gridObj.gridName,
      groupId: 0,
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  grid: any = [];
  gridTemp: any = [];
  gridObj: any = {};

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    this.parentCheckBox = false;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "IMPACT_ASSESSMENT_FIELDS",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? "",
          templateIdFromQmsReportTemplate: this.templateId,
        }
        this.gridObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.getDynamicLabel()
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  onParentChanged(e: any) {
    if (e.target.checked) {
      for (const element of this.grid) { element.childCheckBox = true }
    } else {
      for (const element of this.grid) { element.childCheckBox = false }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
    } else {
      this.parentCheckBox = list.childCheckBox = false;
    }
    this.parentCheckBox = this.grid.every((r: any) => r.childCheckBox);
  }

  refreshGrid() {
    [this.grid, this.gridObj] = [[], {}];
    this.getCall();
  }

  getClobValue(primeIdentifier: string, columnName: string): Promise<string> {
    const docObj = {

      primeIdentifier: primeIdentifier,
      tableView: 'OOS_LAB_INVESTIGATION_CATEGORY_VW', // Update this to the correct view name
      columnName: columnName
    };

    return new Promise((resolve) => {
      this.appService.getClobToViewAudit(docObj).subscribe({
        next: (response: any) => resolve(response.result ?? ''),
        error: (error) => {
          console.error('Error fetching CLOB value:', error);
        },
        complete: () => {
          console.log('CLOB value retrieval completed.');
        }
      });
    });
  }

  focusEmpty() {
    console.log("Focusing...");
  }

}
